var path = 'https://assets.animatron.com/html/news.html';
var html = "<div class=\"news-container\" ng-if=\"NewsCtrl.newsList.length\"> <span class=\"icon\"></span> <div class=\"news-body\"> <div class=\"news-content\" ng-bind-html=\"NewsCtrl.currentNews\"></div> <button class=\"button button-close-message\" ng-click=\"NewsCtrl.deleteNews()\"></button> </div> </div>";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;


// WEBPACK FOOTER //
// ./node_modules/ngtemplate-loader?relativeTo=/assets/&module=templates&prefix=https:/assets.animatron.com/!./node_modules/html-loader?{"root":"/home/buildagent/buildAgent/work/e89b456ed2bb19a7/app/assets","attrs":["img:src","img:ng-src","div:static-include","p:static-include","static-include:src"],"minimize":true,"removeOptionalTags":false,"removeEmptyAttributes":false,"removeIgnored":true,"collapseBooleanAttributes":true,"collapseWhitespace":true,"removeAttributeQuotes":false,"removeComments":true}!./app/assets/html/news.html